import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Utils from "./utils";
import TextField from "@material-ui/core/TextField";

// import OutlinedInput from "@material-ui/core/OutlinedInput";

class CreditNote extends React.Component {
  async downloadPDF(blob, filename) {
    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  async generateAndDownloadPDF(documentType = 'CREDIT NOTE') {
    try {
      // Filter items to only include those with credit quantities
      const creditItems = this.state.products.items.filter(item =>
        item.changeqty && item.changeqty > 0
      ).map(item => ({
        ...item,
        quantity: item.changeqty,
        sellingpricetotal: item.creditvalue || (item.changeqty * item.sellingpriceperunit)
      }));

      if (creditItems.length === 0) {
        alert('No items selected for credit note. Please specify credit quantities.');
        return;
      }

      // Prepare the data for the lambda
      const requestData = {
        items: creditItems,
        patient: this.state.patientname,
        icd: this.state.icd10,
        medicalaidname: this.state.medicalaidname,
        medicalaidnumber: this.state.medicalaidnumber,
        date: this.state.date,
        invoicenumber: this.state.invoicenumber,
        documentType: documentType
      };

      const response = await fetch('https://4qy64aunwvjpd4j7kcqotc5ohi0kevuo.lambda-url.eu-west-1.on.aws/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      if (response.ok) {
        const blob = await response.blob();
        const filename = `${documentType.toLowerCase().replace(' ', '_')}_${this.state.invoicenumber}.pdf`;
        await this.downloadPDF(blob, filename);
      } else {
        const errorData = await response.text();
        alert(`Error generating PDF: ${errorData}`);
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  }

  constructor(props) {
    super(props);
      this.state = props.location.state.trx;
    // this.state = {
    //   docnumber: props.trx.invoicenumber,
    //   transaction: props.trx.transactionnumber,
    //   status: "",
    //   items: props.trx.products.items,
    //   patientname: props.trx.patientname,
    //   icd10: props.trx.icd10,
    //   medicalaidname: props.trx.medicalaidname,
    //   medicalaidnumber: props.trx.medicalaidnumber,
    //   date: new Date(props.trx.date).toDateString(),
    //   invoicenumber: props.trx.invoicenumber,
    //   receiptnumber: props.trx.receiptnumber,
    //   disableinvoice: true,
    //   disablereceipt: true,
    //   totalvalue: props.trx.totalvalue,
    //   id:props.trx.id
    // };
  }

  changeState(index, field, value) {
    var temp = this.state.products.items;
    temp[index][field] = value;
    if ((field === "changeqty") & (value > temp[index].quantity))
      temp[index].changeqty = temp[index].quantity;
    temp[index].creditvalue =
      temp[index].changeqty * temp[index].sellingpriceperunit;
    this.setState({ items: temp });
  }
  changeStateNoPrice(index, field, value) {
    var temp = this.state.products.items;
    temp[index][field] = value;

    this.setState({ items: temp });
  }

  maketablerows(inputitems) {
    return inputitems.map((item, index) => {
      return (
        <TableRow key={item.id}>
          <TableCell>{item.brand}</TableCell>
          <TableCell>{item.product}</TableCell>
          <TableCell>{item.quantity}</TableCell>
          <TableCell>{item.sellingpriceperunit}</TableCell>
          <TableCell>
            <div>
              <TextField
                id="outlined-name"
                label="Credit quantity"
                margin="normal"
                value={item.changeqty || 0}
                onChange={change =>
                  this.changeState(
                    index,
                    "changeqty",
                    Number(change.target.value)
                  )
                }
                variant="outlined"
              />
            </div>
          </TableCell>
          <TableCell>
            <div>
              <TextField
                id="outlined-name"
                label="Credit value"
                margin="normal"
                value={item.creditvalue || 0}
                onChange={change =>
                  this.changeStateNoPrice(
                    index,
                    "creditvalue",
                    Number(change.target.value)
                  )
                }
                variant="outlined"
              />
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  async saveCreditNote(
    items,
    patientname,
    icd10,
    medicalaidname,
    medicalaidnumber,
    date,
    invoicenumber
  ) {
    this.setState({ status: "Saving..." });
    //console.log(medicalaidname);
    let saver = await Utils.saveCreditNote(
      items,
      patientname,
      icd10,
      medicalaidname,
      medicalaidnumber,
      date,
      invoicenumber
    );
    if (saver) {

      this.setState({
        status: "Saved",

      });
    }
  }

  render() {

    return (
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Brand</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Selling price</TableCell>
              <TableCell>Credit quantity</TableCell>
              <TableCell>Credit value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{this.maketablerows(this.state.products.items || null)}</TableBody>
        </Table>
        <Button
          style={{ margin: 2 }}
          variant="contained"
          color="primary"
          onClick={() => this.generateAndDownloadPDF('CREDIT NOTE')}
        >
          Preview credit note
        </Button>
        <Button
          style={{ margin: 2 }}
          variant="contained"
          color="primary"
          onClick={() => {
            this.saveCreditNote(
              this.state.products.items,
              this.state.patientname,
              this.state.icd10,
              this.state.medicalaidname,
              this.state.medicalaidnumber,
              new Date(Date.now()).toDateString(),
              this.state.invoicenumber
            );
          }}
        >
          Save credit note
        </Button>
  {this.state.status}
      </div>
    );
  }
}
export default CreditNote;